// Firebase web config (Checkpoint 5.01). These are the PUBLIC client keys for the existing
// `prettygolf-2e57b` project — the same project classic Firebase Hosting already deploys to.
//
// The `apiKey` here is NOT a secret and is SAFE to commit / ship in the client bundle. It only
// identifies the Firebase project to Google's servers; it grants no privileged access on its own.
// The real security boundary is Firebase Auth (who is signed in) + Firestore security rules (what
// they may read/write) — those land in Phase 1b. (Google's own docs say the web apiKey is meant to
// be in client code.) So this file is a plain committed config module, no env-var indirection.
//
// Values were read from the live project's Hosting reserved config
// (https://prettygolf-2e57b.web.app/__/firebase/init.json) so they match the deployed project exactly.
// `appId` is intentionally omitted — it is only needed for Firebase Analytics, which this slice does
// not use; Auth + Firestore initialise fine without it. Add it (from Firebase console → Project
// settings → your web app) if/when Analytics is wired.
export const firebaseConfig = {
  apiKey: 'AIzaSyAqRv5ieruHwuZK-UiK-DWwQSCbctAh8QE',
  authDomain: 'prettygolf-2e57b.firebaseapp.com',
  projectId: 'prettygolf-2e57b',
  storageBucket: 'prettygolf-2e57b.firebasestorage.app',
  messagingSenderId: '870100901543',
};
